// TODO: Regions: Fix it.
import { getOfficeAddress } from 'consts/address';
import { SetupDataTypes, HomeownerSetupStepNames } from 'models/enums';

export const HOME_OWNER_PAPER_WORK_STRINGS = {
  'userProfile.title': 'Your Member Profile',
  'userProfile.subTitle':
    "Belong is a community, filled with Members such as yourself. Let's help your future Residents get to know\u00a0you!",
  'userProfile.hometown': 'Hometown',
  'userProfile.about_me': 'Tell us about\u00a0yourself.',

  'landing_page.title': 'Let’s get your home\u00a0loved.',
  'landing_page.title_2': 'Keep going!',
  'landing_page.accounts_button': 'Done',
  'landing_page.subtitle':
    "In order to best serve you, we'll ask you a series of questions. We'll only need to ask these once, but you can always let us know in the future if something changes on your\u00a0end.",

  'landing_page.all_about_you.title': 'Take Your Profile To The Next Level',
  'landing_page.all_about_you.subtitle': 'What You Need',
  'landing_page.all_about_you.ID': 'Valid ID',

  'landing_page.get_paid.title': 'Unlock Payments',
  'landing_page.get_paid.subtitle': "Here's what you'll need...",
  'landing_page.get_paid.info': 'Tax Info',

  'landing_page.around_the_property.title': 'Unlock Your Professional Listing',
  'landing_page.around_the_property.subtitle': "Here's what you'll need...",
  'landing_page.around_the_property.HOA_AGREEMENT': 'HOA Agreement',
  'landing_page.around_the_property.HOA_CONTACT_INFO': 'HOA Contact Info',
  'landing_page.around_the_property.HOMEOWNERS_INSURANCE':
    "Proof Of Homeowner's Insurance",

  'landing_page.on_the_inside.single_family': 'Home Info',
  'landing_page.on_the_inside.multi_family': 'Unit {homeNumber} Info',

  'landing_page.on_the_inside.title_for_single_family':
    'Unlock Your Complimentary Walkthrough  ',
  'landing_page.on_the_inside.title_for_multiunit':
    'On The Inside | Unit {homeNumber}',
  'landing_page.on_the_inside.subtitle': "Here's what you'll need...",
  'landing_page.on_the_inside.CURRENT_LEASE': 'Current Lease (If Applicable)',
  'landing_page.on_the_inside.RESIDENT_INFO': 'Resident Contact Info',

  'landing_page.far_off.move_out_on_day': 'Moving out on <span>{date}</span>',
  'landing_page.far_off.move_out_on_month':
    'Moving out in <span>{month}</span>',
  'landing_page.far_off.vacant_on_day': 'Available on <span>{date}</span>',
  'landing_page.far_off.vacant_on_month': 'Available in <span>{month}</span>',

  'around_the_property.title': "Let's make sure we play by the\u00a0rules.",
  'around_the_property.hasHoa.title':
    'Do you have an HOA at {propertyStreetAddress}?',
  'around_the_property.hasHoa.subtitle':
    'Or something similar? If so, we’ll make sure we comply with any and all rules set by your homeowner or neighborhood\u00a0association.',
  'around_the_property.whoIsHoaContact.title':
    'Who is your HOA’s primary\u00a0contact?',
  'around_the_property.whoIsHoaContact.donthave':
    "I don't know. Remind me\u00a0later!",
  'around_the_property.notifiedHoa.title':
    'Have you notified your HOA that Belong will be managing your\u00a0home?',

  'around_the_property.notifiedHoa.falseText':
    'Ok, please do so ASAP and cc us on that email if possible so we can take over the relationship. They may require written authorization as well for us to manage your\u00a0home.',

  'around_the_property.uploadHoa.title': 'Upload your HOA Agreement (CC&Rs).',

  'around_the_property.uploadHoa.donthave':
    "I don't have it. Remind\u00a0me\u00a0later!",

  'around_the_property.uploadHoa.relationship':
    'What’s your relationship like with your\u00a0HOA?',

  'insurance.title': 'Do you have landlord insurance\u00a0yet?',
  'insurance.liability.title':
    'Are you covered for at least $300k in personal liability, and for property damage up to the full value of the\u00a0home?',
  'insurance.liability.no_condition_title':
    'Belong requires our homeowners be insured for carry and pay for the\u00a0following...',
  'insurance.liability.no_condition_sections': [
    'Personal liability insurance in an amount of no less than\u00a0$300,000.',
    'Property damage insurance equal to the full replacement cost of the Property and all of Owner’s personal property thereon, to protect the interests of Owner and\u00a0Belong.',
    'Additional coverage for rent loss should the Property become\u00a0uninhabitable.',
    'Any employees or contractors you employ separately from Belong, worker’s compensation insurance adequate to protect the interests of Owner and\u00a0Belong.',
  ],
  'insurance.liability.interested_party.title':
    'Great! When you get a chance, please add Belong to your policy as an Additional\u00a0Insured\u00a0Party.',
  'insurance.liability.interested_party.custom_option_1': 'I already did!',
  'insurance.liability.interested_party.custom_option_2':
    "Ok, I'll do\u00a0that.",
  'insurance.upload_pdf':
    'Please provide us with proof\u00a0of\u00a0insurance.',
  'insurance.not_added_belong': `Thanks in advance! Please inform your insurance company, and add BELONG\u00a0HOME\u00a0INC. as an Additional Insured Party. Our corporate address is ${getOfficeAddress()}. Once you've done that, please send us the certificate\u00a0of\u00a0insurance.`,

  'around_the_property.anythingelse.title':
    'Anything we should know about them or the\u00a0relationship?',
  'around_the_property.anythingelse.placeholder':
    'Anything we should know? (OPTIONAL)',

  'propertyFeatures.title':
    'Any communal features in or around the property to\u00a0inspect?',
  'propertyFeatures.subtitle':
    "These are just some popular shared features. When we inspect, we'll add every feature we\u00a0find.",
  'propertyFeatures.title_inspection_passed':
    'Last time we checked, we found these communal features on the\u00a0property.',
  'propertyFeatures.missing_features.title':
    'Something missing? Let\u00a0us\u00a0know!',
  'propertyFeatures.other_features.title':
    'Something else? Let\u00a0us\u00a0know!',
  'propertyFeatures.missing_features.placeholder':
    'Missing Features (OPTIONAL)',

  'homeOccupancy.title': `Let's meet your\u00a0renters!`,
  'homeOccupancy.last_time_we_checked.month_to_month':
    'Last time we checked, their lease is month-to-month, and they have not given\u00a0notice.',
  'homeOccupancy.last_time_we_checked.specific_date':
    'Last time we checked, their lease {endsOrEnded} {date}.',
  'homeOccupancy.subtitle':
    "We'll reach out to introduce ourselves, and coordinate with them anytime we come to\u00a0visit.",
  'homeOccupancy.relationship.month_checkbox': 'Month-To-Month',
  'homeOccupancy.relationship.phone_unknown': "I don't know it.",
  'homeOccupancy.relationship.email_unknown': "I don't know it.",
  'homeOccupancy.relationship.email_or_phone_required':
    'Note: We need at least one contact method for your current\u00a0residents.',
  'homeOccupancy.relationship.title':
    "What's your relationship like with\u00a0them?",

  'homeOccupancy.plans_changed':
    'Ok, please update the details of the\u00a0lease.',
  'homeOccupancy.gave_notice': 'Ok, when are they planning to move\u00a0out?',
  'homeOccupancy.already_moved_out.title':
    'Ok, time for us to get to work finding someone new to love your home\u00a0then!',
  'homeOccupancy.already_moved_out.subtitle':
    'Mind if we ask, when did they move\u00a0out?',

  'homeOccupancy.relationship.upload_lease': 'Upload Lease',
  'homeOccupancy.relationship.upload_lease_checkbox': "I don't have it.",
  'homeOccupancy.otherInfo.title':
    'Anything we should know about them or the\u00a0relationship?',
  'homeOccupancy.otherInfo.placeholder': 'Additional Details (OPTIONAL)',

  'homeFeatures.title': 'Time to gush about\u00a0your\u00a0home.',
  'homeFeatures.subtitle': "We'll come verify\u00a0this...",
  'homeFeatures.beds': 'Beds',
  'homeFeatures.baths': 'Full Baths',
  'homeFeatures.half_baths': 'Half Baths',
  'homeFeatures.banner_image.section_title':
    'Have a great photo of the front of your\u00a0home?',
  'homeFeatures.banner_image.section_subtitle':
    "Ideally, this would capture the whole face of your home in frame. We'll use this prior to your upcoming professional\u00a0photoshoot.",
  'homeFeatures.features.section_title':
    'Any features we should\u00a0highlight?',
  'homeFeatures.select_all_that_apply.section_title':
    'Select any that apply. (OPTIONAL)',
  'homeFeatures.features.section_subtitle':
    "These are just some popular ones. When we inspect, we'll add every feature we\u00a0find.",
  'homeFeatures.supported_feature.heat': 'Heat',
  'homeFeatures.supported_feature.ac': 'A/C',
  'homeFeatures.supported_feature.laundry': 'Laundry',
  'homeFeatures.supported_feature.parking': 'Parking',
  'homeFeatures.supported_feature.pool': 'Pool',
  'homeFeatures.supported_feature.lawn': 'Lawn',
  'homeFeatures.supported_feature.garden': 'Garden',
  'homeFeatures.supported_feature.trees_landscaping': 'Trees / Landscaping',
  'homeFeatures.supported_feature.storage': 'Storage',
  'homeFeatures.ac_type.central_ac': 'Central AC',
  'homeFeatures.ac_type.window_units': 'Window-Units',
  'homeFeatures.parking_type.garage': 'Garage',
  'homeFeatures.parking_type.lot': 'Lot',
  'homeFeatures.parking_type.carport': 'Carport',
  'homeFeatures.parking_type.driveway': 'Driveway',
  'homeFeatures.parking_type.on_street_parking': 'On-Street Parking',
  'homeFeatures.parking_type.off_street_parking': 'Off-Street Parking',
  'homeFeatures.home_level_type.ground_level': 'Ground Level',
  'homeFeatures.home_level_type.basement_level': 'Basement Level',
  'homeFeatures.something_missing.section_title':
    'Something missing? Let us know!',
  'homeFeatures.something_else.section_title': 'Something else? Let us know!',
  'homeFeatures.something_missing.placeholder': 'Other Features (OPTIONAL)',
  'homeFeatures.love_about_home.section_title':
    'What do you love about your home? What makes it\u00a0unique?',
  'homeFeatures.love_about_home.placeholder': 'Home Qualities And Uniqueness',
  'homeFeatures.quirks.section_title':
    'What might take some getting used to about living in your home? Any\u00a0quirks?',
  'homeFeatures.quirks.placeholder': 'Quirks',
  'homeFeatures.neighborhood.section_title':
    'What do you love about your\u00a0neighborhood?',
  'homeFeatures.neighborhood.placeholder':
    'Neighborhood Qualities And\u00a0Highlights',
  'homeFeatures.about_neighbors.section_title':
    "What's your relationship like with your\u00a0neighbors?",
  'homeFeatures.about_neighbors.placeholder':
    'Anything we should know? (OPTIONAL)',

  'homeFurnitures.title':
    'Belong Homes come unfurnished. <span>They rent</span> much faster that\u00a0way.',
  'homeFurnitures.furnished.title':
    'Is your home free of all furniture <span>and belongings?</span>',
  'homeFurnitures.furnished.no': 'No, I left stuff.',
  'homeFurnitures.furnished.yes': "Yes, it's empty.",
  'homeFurnitures.furnished.belong_recommendation':
    "On average, furnished homes take 4-5 times as long to rent compared to unfurnished ones. Plus, by law, most damage to furniture is considered normal wear and tear, and therefore cannot be recouped. To get Homeowners such as yourself the most for their home, and protect their furniture, we require all our homes be free of personal items. We'll discuss this with you, and help coordinate anything that needs to be\u00a0removed.",
  'homeFurnitures.not_furnished.disclaimer':
    "Great! Please note that we'll dispose of any items left behind to make sure the home is clean for your new\u00a0Residents.",
  'homeFurnitures.furnitures.title': 'What was left in the\u00a0home?',
  'homeFurnitures.furnitures.item': 'Item',
  'homeFurnitures.furnitures.valuable': 'This item is highly\u00a0valuable.',

  'homeUtilities.title': 'Talk to us about\u00a0utilities...',
  'homeUtilities.Water': 'Water',
  'homeUtilities.Gas': 'Gas',
  'homeUtilities.Electricity': 'Electricity',
  'homeUtilities.Trash': 'Trash',
  'homeUtilities.Sewage': 'Sewage',
  'homeUtilities.Cable': 'Cable',
  'homeUtilities.Internet': 'Internet',
  'homeUtilities.Cleaning': 'Cleaning',
  'homeUtilities.Storage': 'Storage',
  'homeUtilities.Parking': 'Parking',
  'homeUtilities.Landscaping': 'Landscaping',
  'homeUtilities.PoolServicing': 'Pool',
  'homeUtilities.billing_managed_by': 'Who is managing the\u00a0billing?',
  'homeUtilities.responsibility.resident': "Resident's Responsibility",
  'homeUtilities.responsibility.rent': 'Included In Rent',
  'homeUtilities.responsibility.purchase': 'Available For Purchase',
  'homeUtilities.responsibility.hoa': 'Provided By\u00a0My\u00a0HOA',
  'homeUtilities.responsibility.fee': 'Additional Required Fee',
  'homeUtilities.billing_hoa_type.included': 'Included In My HOA Fees',
  'homeUtilities.billing_hoa_type.separately': 'Billed Separately',
  'homeUtilities.billing_cycle.monthly': 'Monthly',
  'homeUtilities.billing_cycle.one_time': 'One-Time',
  'homeUtilities.billing_cycle.quarterly': 'Quarterly',
  'homeUtilities.billing_cycle.annually': 'Annually',
  'homeUtilities.trash_title': 'When is trash day?',
  'homeUtilities.trash_location_title': 'Where is the trash\u00a0located?',
  'homeUtilities.every_2_weeks': 'Every 2 Weeks',

  'inspectionPreferences.title': `Let's come take a\u00a0look!`,
  'inspectionPreferences.subtitle': `Every new Belong home gets one of our signature inspections. These take around 3 hours, during which, we'll
  capture every feature of your home, and document any improvements we recommend. After, we'll send you a full
  report to review\u00a0together.`,
  'inspectionPreferences.presence_preference.title': `First, would you prefer to be\u00a0there?`,
  'inspectionPreferences.presence_preference.subtitle': `Happy to meet you there, but you certainly do not need to be. Up\u00a0to\u00a0you!`,
  'inspectionPreferences.presence_preference.true.first_line': `I want to be\u00a0there.`,
  'inspectionPreferences.presence_preference.true.second_line': `(To meet the\u00a0Inspector)`,
  'inspectionPreferences.presence_preference.false.first_line': `I don't need to be\u00a0there.`,
  'inspectionPreferences.presence_preference.false.second_line': `(Just let me know\u00a0when!)`,
  'inspectionPreferences.availability_time.title': `Great! What times work best for\u00a0you?`,
  'inspectionPreferences.availability_time.subtitle': `While we cannot guarantee a time slot at this time, we'll do our best to accommodate one of the slots you selected. Once we finalize a time, we'll send you a\u00a0confirmation.`,
  'inspectionPreferences.specific_requests.title': `And is there anything you want us to know or take a look at\u00a0specifically?`,
  'inspectionPreferences.specific_requests.subtitle': `For example, any upgrades or renovations you'd like help\u00a0with?`,
  'inspectionPreferences.specific_requests.placeholder': `Specific Requests`,

  'homeKeys.title': 'Keys, please!',
  'homeKeys.subtitle':
    'What keys or remotes will we need for your home? This includes mailbox keys, gate keys, storage\u00a0areas,\u00a0etc.',
  'homeKeys.home_keys.HouseKey': 'House Key',
  'homeKeys.home_keys.FrontDoor': 'Front Door',
  'homeKeys.home_keys.BackDoor': 'Back Door',
  'homeKeys.home_keys.SideDoor': 'Side Door',
  'homeKeys.home_keys.LobbyMainEnterance': 'Lobby',
  'homeKeys.home_keys.Gate': 'Gate',
  'homeKeys.home_keys.Garage': 'Garage',
  'homeKeys.home_keys.Mailbox': 'Mailbox',
  'homeKeys.home_keys.Mailroom': 'Mailroom',
  'homeKeys.home_keys.Storage': 'Storage',
  'homeKeys.home_keys.Other': 'Other',
  'homeKeys.key_types.key': 'Key',
  'homeKeys.key_types.access_code': 'Access Code',
  'homeKeys.key_types.key_fob': 'Key Fob',
  'homeKeys.key_types.remote': 'Remote',
  'homeKeys.key_types.open_access': 'Open Access',
  'homeKeys.key_delivery.title': 'How would you like to get them to\u00a0us?',
  'homeKeys.key_delivery.mail': 'Mail Them',
  'homeKeys.key_delivery.dropoff': 'Drop Them Off',
  'homeKeys.key_delivery.dropoff_subtext': '(In Our Office)',
  'homeKeys.key_delivery.uber': 'Uber them',
  'homeKeys.key_delivery.uber_subtext': '(Free)',
  'homeKeys.key_delivery.inspection': 'Hand It',
  'homeKeys.key_delivery.inspection_subtext': '(At The Inspection)',
  'homeKeys.key_delivery.inspection_text_body':
    'Great! We’ll reach out to schedule a time that works for\u00a0you!',
  'homeKeys.key_delivery.lockbox': 'Lockbox',
  'homeKeys.lockbox.title': 'How do we access this\u00a0lockbox?',
  'homeKeys.lockbox.access_instructions': 'Lockbox Location',
  'homeKeys.lockbox.code': 'Lockbox Code',
  'homeKeys.mailbox.title': 'Tell us about your\u00a0mailbox...',
  'homeKeys.mailbox.access_instructions': 'Mailbox Location',
  'homeKeys.mailbox.number': 'Mailbox Number',
  'homeKeys.mailbox_issue.title':
    'Any issues receiving mail or packages at your\u00a0home?',
  'homeKeys.mailbox_issue.yes': 'Yes, there are\u00a0issues.',
  'homeKeys.mailbox_issue.no': 'No Issues',
  'homeKeys.mailbox_issue.details': 'Mail Issues Description',
  'homeKeys.key_delivery.mail_text_body': 'Great! Please send them to',
  'homeKeys.key_delivery.office_address': (region) => getOfficeAddress(region),
  'homeKeys.key_delivery.dropoff_text_body_1':
    'Great! Please drop by anytime during business hours <span>(M-F 9AM - 7PM)</span>',
  'homeKeys.key_delivery.dropoff_text_body_2': 'We can’t wait to see\u00a0you!',
  'homeKeys.key_delivery.uber_text_body':
    'Great! We’ll reach out to schedule a time that works for\u00a0you!',
  'homeKeys.key_form.name': 'Key Location',
  'homeKeys.key_form.type': 'Key Type',
  'homeKeys.key_form.key_details_key': '# Of Keys',
  'homeKeys.key_form.has_key_key': "I don't have it.",
  'homeKeys.key_form.key_details_access': 'Access Code',
  'homeKeys.key_form.has_key_access': "I don't know it.",
  'homeKeys.key_form.key_details_fob': '# Of Fobs',
  'homeKeys.key_form.has_key_fob': "I don't have it.",
  'homeKeys.key_form.key_details_remote': '# Of Remotes',
  'homeKeys.key_form.has_key_remote': "I don't have it.",

  homeownerSetupTips: {
    [SetupDataTypes.User]: {
      [HomeownerSetupStepNames.UserPersonal]: {
        // title: 'Change of Address?',
        descriptions: [
          'We take the security of your personal information seriously. It stays between us; we’ll never give it\u00a0out.',
        ],
      },
      [HomeownerSetupStepNames.UserIdentity]: {
        // title: 'Fighting Rental Fraud',
        descriptions: [
          'To protect homeowners such as yourself against rental fraud, we verify the identity of each homeowner in our network and match them against the individual on title and payment methods\u00a0added.',
        ],
      },
      [HomeownerSetupStepNames.UserProfile]: {
        // title: 'Fostering Human Connection',
        descriptions: [
          'At Belong, we believe in the importance of fostering human\u00a0connection.',
          "While you won't interact with them directly, we'll use this information to introduce your future Residents to\u00a0you. Putting a face to the name creates good will and encourages better\u00a0behavior.",
        ],
      },
    },
    [SetupDataTypes.UserPayment]: {
      [HomeownerSetupStepNames.UserTaxes]: {
        // title: '',
        descriptions: [
          "Each year, we'll send you a 1099 form and an earnings statement, so you can easily prepare your taxes and claim all allowed\u00a0deductions.",
        ],
      },
      [HomeownerSetupStepNames.UserPaymentMethods]: {
        // title: 'Fostering Human Connection',
        descriptions: [
          'To ensure the security of your financial information, we’ve integrated with Plaid, the indsustry-leading payment provider. Your banking and login information is completely encrypted; all we know is where to send your\u00a0payments.',
        ],
      },
    },
    [SetupDataTypes.Property]: {
      [HomeownerSetupStepNames.PropertyHoa]: {
        // title: 'Managing Relationships',
        descriptions: [
          'HOAs can play an important role when it comes time to do work on your home and provide a great experience for your\u00a0Residents.',
          "Accordingly, we'll build a positive working relationship with them, so they see Belong as a trusted part of the\u00a0team.",
        ],
      },
      [HomeownerSetupStepNames.PropertyInsurance]: {
        // title: '',
        descriptions: [
          "We hate the word <em>landlord</em>... but in this case, we'll make an exception. Landlord insurance covers you in similar ways to homeowners insurance, but provides more tailored protection against the unique aspects of\u00a0renting.",
        ],
      },
      [HomeownerSetupStepNames.PropertyFeatures]: {
        // title: 'During Your Inspection',
        descriptions: [
          "During your inspection, we'll send a professional photographer to capture these amenities, and highlight them to your future\u00a0Residents.",
        ],
      },
    },
    [SetupDataTypes.Home]: {
      [HomeownerSetupStepNames.UnitOccupancy]: {
        // title: 'Everyone Gets The <span>Belong Experience</span>',
        descriptions: [
          "Everyone deserves the Belong Experience. If you have existing renters, we'll make sure they feel like life is getting an\u00a0upgrade.",
          "For anyone else living in the home that may be on their way out, we'll make sure to work around their schedules while we get the home ready to\u00a0show.",
        ],
      },
      [HomeownerSetupStepNames.UnitFeatures]: {
        // title: 'During Your Inspection',
        descriptions: [
          "During your inspection, we'll send a Belong Pro and a professional photographer to capture everything your home has to offer, and add any additional features we\u00a0find.",
          "For now, we'll use this information to give our Members a Coming Soon sneak peek at your home on\u00a0our\u00a0site.",
        ],
      },
      [HomeownerSetupStepNames.UnitPreferencesPets]: {
        // title: 'Being Fur Friendly',
        descriptions: [
          "Consider being fur friendly. Homes that allow pets attract significantly more applications, generate additional monthly income ($75/pet), and result in happier residents that stay longer. But it's up\u00a0to\u00a0you!",
        ],
      },
      [HomeownerSetupStepNames.UnitPreferencesFurnishing]: {
        // title: 'Need Help With Storage?',
        descriptions: [
          'Need help with storage? We can help arrange pickup and storage for any belongings left in the home. Just let us\u00a0know!',
        ],
      },
      [HomeownerSetupStepNames.UnitPreferencesUtilities]: {
        // title: 'Transferring Utilities',
        descriptions: [
          'If your home is vacant, please keep all utilities active and in your name.',
          "Once we find someone to love your home, we'll make sure all the correct utilities are transferred to their\u00a0name.",
        ],
      },
      [HomeownerSetupStepNames.UnitKeys]: {
        // title: 'Key Tip!',
        descriptions: [
          "Here's a key tip! Once we receive your keys, we'll place a lockbox at your home (if possible) and store duplicates securely in our\u00a0office.",
          'For security purposes, we also rekey all Belong homes when we take possession, ensuring no keys out in the wild can be used to compromise your\u00a0home.',
        ],
      },
      [HomeownerSetupStepNames.UnitInspectionPreferences]: {
        // title: 'Why take the time?',
        descriptions: [
          `So why take the time? Belong inspections are thorough, for two\u00a0reasons.`,
          `First, we'll look for anything in the home that may be a risk to you in the future, such as code\u00a0violations.`,
          `Second, we'll make recommendations that help rent your home faster, for as much as\u00a0possible.`,
        ],
      },
      [HomeownerSetupStepNames.UnitDisclosures]: {
        // title: 'Key Tip!',
        descriptions: [
          'We’ll include this information in the lease for your future Residents. These disclosures are required by law or regulation, and may help protect you from liability down the\u00a0road.',
        ],
      },
    },
    landingPage: {
      // title: 'Go, Go, Go!',
      descriptions: [
        'Go, go, go! The sooner you complete this, the sooner we can get to work and get you\u00a0paid.',
      ],
    },
    completedPage: {
      // title: "Now that that's over...",
      descriptions: [
        "Now that that's over, we'll be sending a Pro out to thoroughly inspect your home. By the end, we'll know every nook\u00a0and\u00a0cranny.",
      ],
    },
  },

  personal_info: {
    title: "Let's get to know you better, {firstName}.",
    subTitle:
      'Please confirm your personal\u00a0information so that we can generate tax\u00a0forms and send you documents in\u00a0the\u00a0future.',
    is_name_legal_question: "Is '{firstName} {lastName}' your legal\u00a0name?",
    is_name_legal_yes: "Yes, that's correct.",
    is_name_legal_no: "No, it's different.",
    legal_first_name: 'Legal First Name',
    legal_middle_name: 'Legal Middle Name',
    legal_last_name: 'Legal Last Name',
    current_address: 'Current Address',
    unit_number: 'Unit',
    same_mailing_address: 'This is also my mailing\u00a0address.',
    where_to_send_title: 'Where can we send you important\u00a0documents?',
    mailing_address: 'Mailing Address',
    next_button_text: 'Next',
  },
  success_page: {
    title_line_0: "Great! We've got ",
    title_line_1: 'everything we need!',
    sections: {
      whats_next: {
        title: "What's next?",
        listitems: [
          'Complete your account\u00a0setup.',
          'Get your {home} inspected by a Belong\u00a0Pro.',
          'Have the Pro Team get your {home}\u00a0ready.',
          `We'll find someone to love your\u00a0{home}.`,
        ],
      },
      cant_wait_that_long: {
        title: "Can't wait that\u00a0long?",
        subtitle:
          "We're available to chat anytime between 9am-6pm PST. We'd love to hear from\u00a0you!",
        chatcta: 'CHAT WITH US',
      },
    },
    buttonLabel: 'View Account',
  },
  'identity_verification.title': "Let's make sure you're\u00a0you.",
  'identity_verification.subtitle':
    'Upload a valid\u00a0form\u00a0of\u00a0ID and take\u00a0a\u00a0selfie to verify\u00a0your\u00a0identity.',
  'identity_verification.date_of_birth': 'Date Of Birth (MM/DD/YYYY)',
  'identity_verification.next_button_text': 'Next',

  'pet_preferences.title':
    "Let's talk about some leasing preferences, shall\u00a0we?",
  'pet_preferences.pets_allowed.section_title':
    'May your residents have\u00a0pets?',
  'pet_preferences.pets_allowed.section_sub_title':
    "Note: We're required by law to allow service and emotional support animals. Where allowed, we automatically charge Residents an additional pet security deposit to cover any pet-related wear\u00a0and\u00a0tear.",
  'pet_preferences.pets_allowed.any_pets': 'Any (Legal) Pets',
  'pet_preferences.pets_allowed.dogs_only': 'Dogs Only',
  'pet_preferences.pets_allowed.cats_only': 'Cats Only',
  'pet_preferences.pets_allowed.no_pets': 'No Pets',
  'pet_preferences.how_many_pets.section_title':
    'Up to how many {lowerCaseType} may they\u00a0have?',
  // 'pet_preferences.how_many_pets.label': '# of {lowerCaseType}',
  'pet_preferences.how_many_pets.all_shapes_checkbox':
    'All shapes and sizes are\u00a0welcome.',
  'pet_preferences.select_that_apply.title': 'Any other restrictions?',
  'pet_preferences.weight_restrictions.label':
    'Only {lowerCaseType} under a certain\u00a0weight.',
  'pet_preferences.weight.label': 'Weight Limit (lb)',
  'pet_preferences.breed_restrictions.label':
    'My HOA or insurance restricts certain\u00a0breeds.',
  'pet_preferences.hoa_restrictions.label': 'Restricted Breed(s)',
  'pet_preferences.next_button': 'Done',

  'pet_preferences.pets_allowed.no_pets.confirmation.title':
    'Three Reasons To\u00a0Reconsider',
  'pet_preferences.pets_allowed.no_pets.confirmation.bold': [
    'Increase the market for your\u00a0home.',
    'Worried about wear\u00a0and\u00a0tear?',
    'Happier Residents. Happier\u00a0Home.',
  ],
  'pet_preferences.pets_allowed.no_pets.confirmation.text': [
    'The majority of residents have at least one pet. Opening up to pets increases competition for your\u00a0home.',
    'Residents pay an additional fee for each pet, on top of the security deposit. Should scuffs or stains occur, we’ll handle any repairs ourselves. Plus, we’ll ask about pets when we do a reference check with your Residents’ previous landlord to make sure they were on their best\u00a0behavior.',
    'Last but not least, pets make people happy, generating good will that will translate to better care for your\u00a0home.',
  ],

  disclosures: {
    title: 'Anything important we need to tell future renters\u00a0about?',
    subtitle:
      'Select all legally required disclosures that you know about at <strong>{address}</strong>.',
    describe: 'Could you please\u00a0expand?',
  },
  disclosures_documentation: {
    title: "We've prepared your disclosures\u00a0form.",
    subtitle:
      "As required by law or regulation, we'll include this in your future Residents'\u00a0lease.",
  },
  user_payment_w9: {
    individual_title: 'We’ve prepared a W-9 for\u00a0you\u00a0to\u00a0sign.',
    business_title: 'We’ve prepared a W-9 for <div>{businessName}.</div>',
    subtitle:
      'Based on this, we will send you a 1099 come\u00a0tax\u00a0season.',
  },
  user_payment_methods: {
    title: "Let's get you\u00a0paid!",
    subtitle:
      'Belong will send you rent for this home, less any fees, via the payment method of\u00a0your\u00a0choice.',
  },

  'banner.get_inspected': `As soon as you complete, we'll schedule the appointment, with slots as early as\u00a0tomorrow.`,
  'banner.get_inspected_date': `As soon as you complete, we'll schedule the appointment, with slots as early as\u00a0{date}.`,

  'unlock_animation.multiple_units.inspection': `Congratulations! You've unlocked the inspection for {address}!`,
  'unlock_animation.multiple_units.listing': `Alright! You've unlocked the listing for {address}!`,
  'unlock_animation.multiple_units.payment': `Hooray! You've unlocked rent payments for {address}!`,
  'unlock_animation.single_unit.inspection': `Congratulations! You've unlocked your home's\u00a0inspection!`,
  'unlock_animation.single_unit.listing': `Alright! You've unlocked your home's\u00a0listing!`,
  'unlock_animation.single_unit.payment': `Hooray! You've unlocked rent\u00a0payments!`,
};

// Increase the market for your home.
// The majority of residents have at least one pet. Opening up to pets increases competition for your home.

// Worried about wear and tear?
// Residents pay an additional fee for each pet, on top of the security deposit. Should scuffs or stains occur, we’ll handle any repairs ourselves. Plus, we’ll ask about pets when we do a reference check with your Residents’ previous landlord to make sure they were on their best behavior.

// Happier Residents. Happier Home.
// Last but not least, pets make people happy, generating good will that will translate to better care for your home.
